import { useCallback } from 'react';
import { TaskStatusType } from '@/types/admin/tasks';
import { useArchiveTaskMutation, useDeleteTaskMutation, useDuplicateTaskMutation, useQuickCreateTaskMutation } from '@/store/api/admin/tasksApi';

export const useTasksActions = (selectedPropertyId?: number) => {
  const [quickCreateTask, { isLoading: isQuickCreating }] = useQuickCreateTaskMutation();
  const [archiveTask] = useArchiveTaskMutation();
  const [duplicateTask] = useDuplicateTaskMutation();
  const [deleteTask] = useDeleteTaskMutation();

  const handleQuickCreateTask = useCallback(async (title: string, taskStatus: TaskStatusType) => {
    if (!selectedPropertyId || !title.trim()) return;
    await quickCreateTask({ title: title.trim(), taskStatus, propertyId: selectedPropertyId }).unwrap();
  }, [selectedPropertyId, quickCreateTask]);

  const handleArchiveTask = useCallback(async (taskId: number, isArchived: boolean = true) => {
    await archiveTask({ taskId, isArchived, archivedAt: isArchived ? new Date().toISOString() : null }).unwrap();
  }, [archiveTask]);

  const handleDuplicateTask = useCallback(async (taskId: number, getOriginal: (id: number) => any) => {
    if (!selectedPropertyId) throw new Error('No property selected');
    const originalTask = getOriginal(taskId);
    if (!originalTask) throw new Error('Task not found');
    await duplicateTask({ taskId, originalTask, selectedPropertyId }).unwrap();
  }, [duplicateTask, selectedPropertyId]);

  const handleDeleteTask = useCallback(async (taskId: number) => {
    await deleteTask({ taskId }).unwrap();
  }, [deleteTask]);

  return { handleQuickCreateTask, handleArchiveTask, handleDuplicateTask, handleDeleteTask, isQuickCreating } as const;
};


